import {Button, Form, Input} from "antd";
import Checkbox from "antd/es/checkbox/Checkbox";
import {URL_LOGIN} from "../../const";
import React from "react";

export default ({ins}) => {
    return (
        <Form
            layout={'vertical'}
            ref={ins.formRef}
            name='sam_gallery_signup'
            style={{backgroundColor: '#ffffff', padding: 24, paddingBottom: 0, paddingTop: 0}}
            initialValues={{
                remember: true
            }}
            onFinish={ins.onFinishGallery}
            onValuesChange={(changed, allFields) => {
                ins.setState(changed)
            }}
        >
            <Form.Item
                name='email'
                label={<span style={{fontSize: '16px'}}>Work Email</span>}
                rules={[
                    {
                        required: true,
                        message: 'Please input your Work Email!'
                    }
                ]}
            >
                <Input/>
            </Form.Item>
            <Form.Item
                initialValue={ins.inviteCode ?? ''}
                name='invite_code'
                label={<span style={{fontSize: '16px'}}>Invite Code</span>}
                rules={[
                    {
                        required: true,
                        message: 'Please input the invite code you get from RevArt'
                    }
                ]}
            >
                <Input/>
            </Form.Item>
            <Form.Item
                label={<span style={{fontSize: '16px'}}>Password</span>}
                name='password'
                rules={[
                    {
                        required: true,
                        message: 'Please input your Password!'
                    },
                    {min: 8, message: 'Password must be minimum 8 characters.'}
                ]}
            >
                <Input type='password'/>
            </Form.Item>
            <Form.Item
                label={<span style={{fontSize: '16px'}}>Confirm Password</span>}
                name='confirm_password'
                rules={[
                    {
                        required: true,
                        message: 'Please input your Password again!'
                    },
                    ({getFieldValue}) => ({
                        validator(rule, value) {
                            if (!value || getFieldValue('password') === value) {
                                return Promise.resolve()
                            }
                            return Promise.reject('The two passwords that you entered do not match!')
                        }
                    })
                ]}
                dependencies={['password']}
            >
                <Input type='password'/>
            </Form.Item>

            <Form.Item>
                <Checkbox defaultChecked>
                    Get emails from RevArt about product updates, industry news, and events.
                    <br/>
                    <a href={'https://revart.co/privacy/'} target={'_blank'} rel='noreferrer'>
                        Privacy Policy
                    </a>
                </Checkbox>
            </Form.Item>

            <Form.Item>
                <Button
                    size={'large'}
                    type='primary'
                    htmlType='submit'
                    loading={ins.state.confirmLoading}
                    style={{width: '100%', backgroundColor: '#050a30', fontWeight: 700}}
                >
                    Create Account
                </Button>
                <p style={{fontSize: 16, textAlign: 'center'}}>
                    Have an account? <a href={URL_LOGIN + ins.search_key}>Sign in</a>
                </p>
            </Form.Item>
        </Form>
    )
}